"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VarsValueTypeHandler = exports.VarsMetaValue = exports.VarsMetaSymbol = void 0;
exports.isVarsMetaValue = isVarsMetaValue;
exports.toMetaValue = toMetaValue;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _variable = require("../variable");
var _VarsValue = require("../VarsValue");
const VarsMetaSymbol = exports.VarsMetaSymbol = Symbol.for("MetaSymbol");
class VarsMetaValue {
  constructor(value, metaType, data) {
    (0, _defineProperty2.default)(this, "value", void 0);
    (0, _defineProperty2.default)(this, VarsMetaSymbol, void 0);
    Object.assign(this, data);
    this[VarsMetaSymbol] = metaType;
    this.value = value;
  }
  toString() {
    var _this$value;
    return (_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.toString();
  }
  valueOf() {
    return this.value;
  }
}
exports.VarsMetaValue = VarsMetaValue;
function toMetaValue(value, metaType, data) {
  return {
    type: "value",
    value: new VarsMetaValue(value, metaType, data)
  };
}
function isVarsMetaValue(value) {
  return value && typeof value === "object" && VarsMetaSymbol in value;
}
class VarsValueTypeHandler {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "value");
  }
  value(val) {
    if (isVarsMetaValue(val.value)) {
      return val.value.valueOf();
    }
    return val.value;
  }
  meta(val, key) {
    if (isVarsMetaValue(val.value)) {
      return val.value[key];
    }
    return null;
  }
  truthy(val) {
    if ((0, _VarsValue.isVarsPrimitive)(val.value)) {
      if (typeof val.value === "string") {
        return val.value && val.value !== "0";
      } else {
        return !!val.value;
      }
    } else if ((0, _VarsValue.isVarsArray)(val.value)) {
      return val.value.length > 0;
    }
    return !!val.value;
  }
  address(val) {
    if (typeof val.value === "string") {
      return val.value;
    }
    return null;
  }
  stringValue(value) {
    let val = this.value(value);
    if ((0, _VarsValue.isVarsPrimitive)(val)) {
      return val.toString();
    }
    return null;
  }
  numeric(value) {
    if (typeof value.value === "string") {
      let bn = new _bignumber.default(value.value);
      if (bn.isNaN()) {
        return null;
      }
      return bn;
    }
    if (typeof value.value === "number") {
      return new _bignumber.default(value.value);
    }
    if (Array.isArray(value.value)) {
      let values = [];
      for (let it of value.value) {
        if (typeof it === "string" || typeof it === "number") {
          values.push(new _bignumber.default(it));
        }
      }
      return values;
    }
    return null;
  }
  readPath(val, path) {
    return (0, _variable.readReferencePath)(val.value, path);
  }
}
exports.VarsValueTypeHandler = VarsValueTypeHandler;
//# sourceMappingURL=VarsValueTypeHandler.js.map